export default "__VITE_ASSET__43d546ce__"